export default "__VITE_ASSET__c7DCQIa___ 700w, __VITE_ASSET__YZzSC68v__ 500w";